/*@ngInject*/
const ManageScoringRulesRepository = function (baseRepository) {

    angular.extend(this, baseRepository);


};

angular.module('ums.configuration')
    .service('manageScoringRulesRepository', ManageScoringRulesRepository);

